import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AccountRoutingModule } from './account-routing.module';
import { NWMControls } from 'app/components/Controls/NWMControls.module';
import { AccountComponent } from './account.component';
import { LoginHelpComponent } from './login-help.component';
import { LoginComponent } from './login.component';
import { LogoutComponent } from './logout.component';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        RouterModule,
        AccountRoutingModule,
        NWMControls,
        LoginComponent,
        LogoutComponent,
        AccountComponent,
        LoginHelpComponent,
    ],
    providers: []
})
export class AccountModule{}
